import { classNames } from "@opensea/ui-kit"

const statClassName = "grow justify-end"

export const PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES = {
  checkbox: "w-6",
  item: "w-[160px] grow",
  listingPrice: classNames(statClassName, "w-[120px]"),
  rarity: classNames(statClassName, "w-[60px]"),
  floor: classNames(statClassName, "w-[110px]"),
  bestOffer: classNames(statClassName, "w-[120px]"),
  cost: classNames(statClassName, "w-[110px]"),
  received: classNames(statClassName, "w-[110px]"),
}
